export interface NoMilesLabel {
  label: string;
  summaryLink: string;
  id: string;
}

export interface WithMilesLabel {
  label: string;
  summaryLink: string;
  id: string;
}

export interface AEMAction {
  label: string;
  noMilesLabel: NoMilesLabel;
  withMilesLabel: WithMilesLabel;
}

export interface AEMSummary {
  action: AEMAction;
  availableMilesLabel: string;
  description: string;
  title: string;
}
